<template>
  <span>

    <div v-if="role === 'process-manager'">
      <span
        style="font-size: smaller;"
        class="text-nowrap"
      >
        {{ data.item.payment_status }}
      </span>
    </div>
    <div v-else>
      <div
        v-b-popover.hover.topright.html="getSpan( data.item.payment_status , 'payment' )"
        class="hover-pointer"
        @click="
          $router.push({
            name: 'edit-payment-status',
            params: { id: data.item.id }
          })
        "
      >
        <span
          style="font-size: smaller;"
          class="text-nowrap"
        >
          {{ data.item.payment_status }}
        </span>
      </div>
    </div>

  </span>
</template>

<script>
export default {
  name: 'PaymentStatusCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    getSpan: {
      type: Function,
      required: true,
    },
  },
}
</script>
